import type { ReactNode } from "react";

type ExpenseDetailFieldProps = {
  label: string;
  children: ReactNode;
  className?: string;
};

export function ExpenseDetailField({
  label,
  children,
  className,
}: ExpenseDetailFieldProps) {
  return (
    <div className={className}>
      <p className="font-medium text-[0.65rem] text-muted-foreground uppercase tracking-wide">
        {label}
      </p>
      <div className="mt-1 text-sm leading-snug">{children}</div>
    </div>
  );
}
